var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnCarouselArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 95",
    style: {
      enableBackground: "new 0 0 55 95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.4,94c-1.7,0-3.4-0.6-4.7-1.9L2.9,52.2c-2.6-2.6-2.6-6.8,0-9.4L42.7,2.9c2.6-2.6,6.8-2.6,9.4,0 s2.6,6.8,0,9.4L17,47.5l35.1,35.2c2.6,2.6,2.6,6.8,0,9.4C50.8,93.4,49.1,94,47.4,94z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCarouselArrow);
export default __webpack_public_path__ + "static/media/btn_carousel-arrow.fbc60af8ffd64d4a87e9eba134fcf45e.svg";
export { ForwardRef as ReactComponent };